import { render, staticRenderFns } from "./AllPostPlatForm.vue?vue&type=template&id=628b6daf&scoped=true&"
import script from "./AllPostPlatForm.vue?vue&type=script&lang=js&"
export * from "./AllPostPlatForm.vue?vue&type=script&lang=js&"
import style0 from "./AllPostPlatForm.vue?vue&type=style&index=0&id=628b6daf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628b6daf",
  null
  
)

export default component.exports